import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Button from 'react-bootstrap/lib/Button';
import classnames from 'classnames';

import t from '../../lib/I18n';

import Alert, { bAlertType } from '../general/BAlert';
import Loading from '../general/Loading';

export default class DefaultLoginLayout extends React.PureComponent {
    static propTypes = {
        userInput: PropTypes.node.isRequired,
        passwordInput: PropTypes.node.isRequired,
        onLogin: PropTypes.func,
        forgotPasswordButton: PropTypes.node,
        error: PropTypes.string,
        isLoggingIn: PropTypes.bool,
        withSubmitButton: PropTypes.bool
    };

    static defaultProps = {
        onLogin: _.noop,
        forgotPasswordButton: null,
        isLoggingIn: false,
        withSubmitButton: false
    };

    render() {
        const {
            userInput,
            passwordInput,
            onLogin,
            forgotPasswordButton,
            isLoggingIn,
            error,
            withSubmitButton
        } = this.props;

        const errorMessage = error && (
            <Alert
                type={ bAlertType.DANGER }
                className="margin-bottom"
                focusOnload
            >
                {error}
            </Alert>
        );

        return (
            <div>
                <div style={ { position: 'relative' } }>
                    <div
                        className={ classnames('login-form', {
                            'loading-backdrop': isLoggingIn
                        }) }
                    >
                        {errorMessage}
                        {userInput}
                        {passwordInput}
                    </div>
                    {isLoggingIn && (
                        <Loading unwrapped className="loading--centered" />
                    )}
                </div>

                {forgotPasswordButton}

                {withSubmitButton && (
                    <Button
                        bsStyle="primary"
                        className="show btn-lg margin-top--sm"
                        onClick={ onLogin }
                        disabled={ isLoggingIn }
                    >
                        {t('account.login')}
                    </Button>
                )}
            </div>
        );
    }
}
